module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="form-horizontal col-md-8 col-xs-8">\r\n    <div class="form-group">\r\n        <label class="col-md-3 col-xs-3 control-label" for="action">Action:</label>\r\n        <div class="col-xs-9 col-md-9">\r\n            <select id="action" class="form-control col-md-3 col-xs-3">\r\n                <option value="sign">SIGN</option>\r\n                <option value="obsolete">OBSOLETE</option>\r\n            </select>\r\n        </div>\r\n    </div>\r\n    <div class="form-group">\r\n        <label class="col-md-3 col-xs-3 control-label" for="action-time" id="action-time-label">Signature date:</label>\r\n        <div class="col-xs-9 col-md-9">\r\n            <input type="text" class="form-control col-md-6 col-xs-6" id="action-time">\r\n        </div>\r\n    </div>\r\n    <div class="form-group">\r\n        <input id="file-input" name="file" type="file" class="file" data-show-caption="true">\r\n    </div>\r\n</div>';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/templates/documents/document-action-by-document-view.html
// module id = 422
// module chunks = 0